module.exports = __webpack_public_path__ + "static/media/03_avatar_male.32596ae3.png";